module.exports = __webpack_public_path__ + "img/chip3.9b32b23e.png";